var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-base-main',{scopedSlots:_vm._u([{key:"table",fn:function(){return [_c('gj-table',{attrs:{"name":"inventoryConfig","data":_vm.tableData,"columns":_vm.columns,"show-overflow":false,"show-pagination":false},scopedSlots:_vm._u([{key:"configId",fn:function(ref){
var index = ref.index;
var row = ref.row;
return [(row.quota === '滞销库龄区间')?[_c('gj-select',{attrs:{"value":row.configId,"multiple":"","collapse-tags":"","options":[
                  {id: 0, text: '0-90天库龄'},
                  {id: 1, text: '91-180天库龄'},
                  {id: 2, text: '181-270天库龄'},
                  {id: 3, text: '271-365天库龄'},
                  {id: 4, text: '365天以上库龄'}
                ],"clearable":false,"width":"200px"},on:{"input":function($event){return _vm.changeConfig($event)}}})]:_vm._e()]}}])})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }